<template>
  <button
    type="button"
    class="hub-featured-card"
    @click="$emit('click')"
  >
    <div class="hub-featured-card__header">
      <OmtTypography
        as="h3-semi-bold"
        color="#ffffff"
        class="hub-featured-card__eyebrow"
      >
        {{ eyebrow }}
      </OmtTypography>
      <span class="hub-featured-card__badge">{{ badge }}</span>
    </div>
    <div class="hub-featured-card__panel">
      <div class="hub-featured-card__photo">
        <img
          :src="image"
          alt=""
        />
      </div>
      <div class="hub-featured-card__copy">
        <OmtTypography
          as="h2-bold"
          color="#ffffff"
          class="hub-featured-card__title"
        >
          {{ title }}
        </OmtTypography>
        <OmtTypography
          as="p1"
          color="#ffffff"
          class="hub-featured-card__description"
        >
          {{ description }}
        </OmtTypography>
        <OmtTypography
          as="h2-bold"
          color="#0D1A4D"
          class="hub-featured-card__cta"
        >
          {{ ctaLabel }}
        </OmtTypography>
      </div>
    </div>
  </button>
</template>

<script>
export default {
  name: "HubFeaturedCard",
  props: {
    eyebrow: { type: String, required: true },
    badge: { type: String, required: true },
    title: { type: String, required: true },
    description: { type: String, required: true },
    ctaLabel: { type: String, required: true },
    image: { type: String, required: true }
  }
};
</script>

<style scoped>
.hub-featured-card {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  min-width: 0;
  align-self: stretch;
  margin: 0;
  padding: 14px;
  text-align: left;
  color: #fff;
  background: #1c9fff;
  border: 0;
  border-radius: 16px;
  cursor: pointer;
  font-family: inherit;
}

.hub-featured-card:focus-visible {
  outline: 2px solid #0d1a4d;
  outline-offset: 2px;
}

.hub-featured-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-width: 0;
}

.hub-featured-card__eyebrow,
.hub-featured-card__title,
.hub-featured-card__description,
.hub-featured-card__cta {
  margin: 0;
}

.hub-featured-card__eyebrow {
  min-width: 0;
}

.hub-featured-card__badge {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  border-radius: 999px;
  background: #0d1a4d;
  color: #fff;
  font-family: "Open Sans", Roboto, sans-serif;
  font-size: 10px;
  font-weight: 700;
  line-height: 12px;
  letter-spacing: 0.2px;
  text-transform: uppercase;
  white-space: nowrap;
}

.hub-featured-card__panel {
  display: flex;
  align-items: stretch;
  gap: 12px;
  flex: 1;
  min-height: 104px;
  padding: 10px;
  background: #49b2ff;
  border-radius: 12px;
}

.hub-featured-card__photo {
  flex: 0 0 96px;
  width: 96px;
  border-radius: 8px;
  overflow: hidden;
  align-self: stretch;
}

.hub-featured-card__photo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 68% 72%;
  display: block;
}

.hub-featured-card__copy {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
  min-width: 0;
  padding: 4px 0;
}

.hub-featured-card__cta {
  margin-top: 6px;
}

@media screen and (min-width: 1024px) {
  .hub-featured-card {
    gap: 8px;
    padding: 12px;
  }

  .hub-featured-card__badge {
    padding: 4px 8px;
    font-size: 10px;
  }

  .hub-featured-card__panel {
    gap: 10px;
    min-height: 92px;
    padding: 8px;
  }

  .hub-featured-card__photo {
    flex-basis: 72px;
    width: 72px;
  }
}
</style>
